import React, { useState } from 'react'
import { useSelector } from '~/store/hooks'

import { useEventListener } from 'react-recipes'
import { Link } from 'gatsby'
import trads from '~/intl/trads.json'
import Image from '~/components/core/Image'
import { ChevronRight } from '~/icons/ChevronRight'
import transformLink from '~/utils/transformLink'

const PushPreview = ({ items, autoItems }) => {
  // local state
  const [isOpen, setIsOpen] = useState(true)

  // redux lang
  const lang = useSelector((state) => state.lang)

  // ref
  const pushPreview = React.createRef()

  // managed closing/opening panel on scroll
  const handleScroll = () => {
    if (pushPreview.current !== null) {
      let checkIfOpened =
        window.scrollY + 64 >
        pushPreview.current.parentNode.parentNode.offsetTop
          ? false
          : true
      setIsOpen(checkIfOpened)
    }
  }

  // scroll event listener
  useEventListener('scroll', handleScroll)

  let pushs = items

  if (!items && !!autoItems) {
    pushs = autoItems.nodes ? autoItems.nodes : autoItems
  }

  return (
    <>
      {pushs?.length > 0 && (
        <div className="push-preview" ref={pushPreview}>
          <div className={`push-preview__inner ${!isOpen && 'is-close'}`}>
            <button
              className="push-preview__button"
              onClick={() => setIsOpen(!isOpen)}
              aria-label="open-preview"
            >
              <ChevronRight className="icon-white" />
            </button>

            <div className="push-preview__wrapper">
              <h2 className="text-label text-label--bg text-label--big bg-blue text-white mb-5">
                {trads[lang].readAlso}
              </h2>

              <ul className="push-preview__list">
                {pushs.map((item, i) => {
                  let datas, page, url, title
                  let mainImage = null

                  if (items !== null && items !== undefined) {
                    datas = item.fields ? item.fields : item
                    page = item.fields ? datas.page.fields : datas.page
                    url = transformLink(datas.page, false, false).url

                    title = page.title

                    if (page.mainImage) {
                      mainImage = page.mainImage
                    }
                  } else {
                    url = transformLink(item, false, false).url
                    title = item.fields ? item.fields.title : item.title
                    mainImage = item.fields
                      ? item.fields.mainImage
                      : item.mainImage
                  }

                  return (
                    <li className="push-preview__item" key={i}>
                      <Link to={url}>
                        <div
                          className={`picture ${!mainImage && 'picture--empty'}`}
                        >
                          {mainImage ? (
                            <Image
                              classes="w-full"
                              width="100"
                              height="100"
                              image={mainImage}
                            />
                          ) : (
                            <img src="/img/logo.svg" alt="Terega" />
                          )}
                        </div>
                        <p className="name">{title}</p>
                      </Link>
                    </li>
                  )
                })}
              </ul>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default PushPreview
